import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

// https://webpack.js.org/guides/dependency-management/#requirecontext
const modulesFiles = require.context('./modules', true, /\.js$/);

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((moduless, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
  const value = modulesFiles(modulePath);
  moduless[moduleName] = value.default;
  return moduless;
}, {});

const store = new Vuex.Store({
  modules,
  getters,
  plugins: [createPersistedState({
    storage: window.sessionStorage,
    reducer(value) {
      return {
        utils: value.utils,
      };
    },
  })],
});

export default store;
